import { SVG, SVGProps } from './svg'

export function IconDrawingActionDelete(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 32 32">
      <path
        fillRule="evenodd"
        d="M13.5 7c0-.3.2-.5.5-.5h4c.3 0 .5.2.5.5v1.5h-5V7Zm6 0v1.5H24a.5.5 0 0 1 0 1h-.5l-.9 13.7c0 1.3-1.2 2.3-2.5 2.3H12c-1.3 0-2.4-1-2.5-2.3L8.5 9.5H8a.5.5 0 0 1 0-1h4.5V7c0-.8.7-1.5 1.5-1.5h4c.8 0 1.5.7 1.5 1.5Zm-10 2.5h13l-.9 13.6c0 .8-.7 1.4-1.5 1.4H12c-.8 0-1.5-.6-1.5-1.4L9.5 9.5Zm7 4a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0v-7ZM19 13c.3 0 .5.2.5.5v7a.5.5 0 0 1-1 0v-7c0-.3.2-.5.5-.5Zm-5.5.5a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0v-7Z"
      />
    </SVG>
  )
}
